import type { DateRangeApplyResolver } from '@components/DatePicker/DateRangePicker/DateRangePicker';

export const resolveHotelSearchRangeOnApply: DateRangeApplyResolver = ({
  startDate,
  endDate,
  minimumNights,
  isOutsideRange,
  isDayBlocked,
}) => {
  if (!startDate) return null;
  if (endDate) return { startDate, endDate };

  const checkoutDate = startDate.clone().add(1, 'day');
  const doesNotMeetMinimumNights =
    checkoutDate.diff(startDate, 'days') < minimumNights;

  if (
    doesNotMeetMinimumNights ||
    isOutsideRange(checkoutDate) ||
    isDayBlocked?.(checkoutDate)
  ) {
    return null;
  }

  return { startDate, endDate: checkoutDate };
};
